/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ELogBusinessEventName, ELogBusinessEventType, logBusinessEvent } from '../../../../modules/logging';
import { orderEventMapping, orderEventType } from '../../../../modules/logging/loggingConstants';
import { makeSelectGuardComponents } from '../../../../modules/role';
import { ITableLinkProps } from '../../../../modules/table';
import { openExternalRoute } from '../../../../routes/constants/externalRoutes';
import { getPageOrderIdUrl, isPageOrderIdExternalUrl } from '../../../PageOrderId';


export const useTableOrderCellAction = (actionId: number, historyId: string, value: string): ITableLinkProps => {

    const dispatch = useDispatch();
    const componentsFeature = useSelector(makeSelectGuardComponents());

    const onClick = useCallback(() => {
        dispatch(logBusinessEvent({
            eventName: orderEventMapping[orderEventType.user][actionId]
                || ELogBusinessEventName.USER_SERVICES_ORDER_INFO,
            type: ELogBusinessEventType.common,
        }));
        if (isPageOrderIdExternalUrl(componentsFeature)) {
            openExternalRoute(getPageOrderIdUrl(componentsFeature, historyId));
        }
    }, [componentsFeature, actionId, historyId]);

    return {
        isExternalUrl: isPageOrderIdExternalUrl(componentsFeature),
        url: getPageOrderIdUrl(componentsFeature, historyId),
        onClick,
        children: value,

        noValue: !actionId || !historyId || !value,
    };
};
